import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from "react";
import { TableFooter, TableRow, TableCell, RaiseColors, makeStyles } from "componentLibrary";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    footerContainer: {
      boxShadow: "0px -5px 11px 0px ".concat(RaiseColors.midnight, "14"),
      background: "white",
      position: "sticky",
      bottom: 0,
      borderRadius: "16px"
    },
    row: {
      borderBottomLeftRadius: "16px",
      borderBottomRightRadius: "16px"
    },
    cell: {
      borderStyle: "none",
      borderBottomLeftRadius: "16px",
      borderBottomRightRadius: "16px"
    }
  };
});
var FooterRow = function FooterRow(_ref) {
  var headers = _ref.headers,
    footerData = _ref.footerData;
  var classes = useStyles();
  return /*#__PURE__*/_jsx(TableFooter, {
    className: classes.footerContainer,
    children: /*#__PURE__*/_jsx(TableRow, {
      className: classes.row,
      children: headers === null || headers === void 0 ? void 0 : _mapInstanceProperty(headers).call(headers, function (header, cellIndex) {
        var _header$renderFooterC;
        return /*#__PURE__*/_jsx(_Fragment, {
          children: header.renderFooterCell ? /*#__PURE__*/_jsx(TableCell, {
            className: classes.cell,
            children: (_header$renderFooterC = header.renderFooterCell) === null || _header$renderFooterC === void 0 ? void 0 : _header$renderFooterC.call(header, {
              footerData: footerData
            })
          }, cellIndex) : /*#__PURE__*/_jsx(TableCell, {
            className: classes.cell
          })
        });
      })
    })
  });
};
export default FooterRow;